import logo from "../img/Logo.svg"

export const Header = () =>{
    return(
        <header>
            <div className="flex header container1">
                <img src={logo} />
                <div className="flex menu">
                    <a href="#about">About</a>
                    <a href="#pricing">Pricing</a>
                    <a href="#earth">Testimonials</a>
                    <a href="#footer">Help</a>
                </div>

                <div className="flex registartion">
                    <a href="">Sign In</a>
                    <button className="head-button">Sign Up</button>
                </div>
            </div>
        </header>
    )
}